exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__content___1tWYY h2{font-weight:400;margin-bottom:.5em}.index-module__content___1tWYY .index-module__text___1SbEL{margin-bottom:1.5em;font-size:18px}.index-module__content___1tWYY .index-module__dropdown___ViLs6{max-width:500px;margin-bottom:5.5em}", ""]);

// exports
exports.locals = {
	"content": "index-module__content___1tWYY",
	"text": "index-module__text___1SbEL",
	"dropdown": "index-module__dropdown___ViLs6"
};